import { cva } from 'class-variance-authority';

export const SIGNATURE_PANE_CLIP_CLASSES = 'min-h-0 overflow-hidden';

export const SIGNATURE_PANE_BODY_CLASSES = 'flex flex-col gap-2 p-3';

export const SIGNATURE_READ_ONLY_BOX_CLASSES = [
  'min-h-10 cursor-not-allowed whitespace-pre-wrap break-words',
  'rounded-md bg-grey-100 px-3 py-2 text-body-small text-grey-700',
].join(' ');

export const signatureSkeletonBarStyles = cva('h-3 max-w-full rounded bg-grey-300', {
  variants: {
    line: {
      name: 'w-32',
      agency: 'w-44',
      email: 'w-56',
    },
  },
});
